module.exports = __webpack_public_path__ + "img/icon_nav_msg.c468ac7e.svg";